/**
 * PATH: packages/ui/src/undo/inputGuard.ts
 * FILE_ID: UI-UNDO-INPUTGUARD-001
 * PURPOSE: One shared predicate answering "is the user typing right now?"
 * LANDMINE: Promoted from kanban/undo/inputGuard.ts. Kanban keeps a
 *      re-export shim. Ctrl/Cmd+Z must never steal native text undo.
 */

/**
 * f(eventTarget) -> true when key events should be left to the focused
 * editing surface. Covers INPUT / TEXTAREA / SELECT and any
 * contenteditable host (rich-text comment editors set the flag on a
 * wrapper div, so we check `isContentEditable` — which walks the
 * inherited attribute — rather than the attribute itself).
 */
export function isTextInputTarget(target: EventTarget | null): boolean {
  if (!target || typeof target !== 'object') return false
  const el = target as Partial<HTMLElement> & { tagName?: string }
  if (typeof el.tagName !== 'string') return false
  return (
    el.tagName === 'INPUT'
    || el.tagName === 'TEXTAREA'
    || el.tagName === 'SELECT'
    || el.isContentEditable === true
  )
}
